import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {
  squares = [
    { label: 'Recadastramento de Ativos', img:"assets/img/bt-recadastramento-branca.svg", link: "recadastramento" },
    { label: 'Auxílio Saúde de Inativos', img:"assets/img/bt-seguro-saude-branco.svg", link: "formularios-srh/auxilio-saude/lista-solicitacoes" },
/*    { label: 'Auxílio Saúde de Inativos', img:"assets/img/bt-recadastramento-branca.svg", link: "recadastramento" },
    { label: 'Auxílio Saúde de Inativos', img:"assets/img/bt-recadastramento-branca.svg", link: "recadastramento" },*/
    { label: 'Bens & Valores', img:"assets/img/bt-bens-e-valores-branco.png", link: "bensValores" },
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  onSquareClick(square: any) {
    this.router.navigate([square.link]);
  }

}
